import { createClient } from '@supabase/supabase-js';
import { createDiagnosticFetch } from './supabaseFetchDiagnostics';
import { createNoStoreFetch } from './supabaseNoStoreFetch';
// Reads an auth email link from the URL (see authRedirect.js). Imported for
// that side effect, so it runs before the client below is created.
import './authRedirect';

const url = (import.meta.env.VITE_SUPABASE_URL || '').trim();
const anon = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();

if (!url || !anon) {
  console.error('Supabase envs missing:', { url, hasAnon: Boolean(anon) });
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

// Every request skips the browser's HTTP cache, so Back to a page never shows
// a list as an earlier visit fetched it (see supabaseNoStoreFetch.js). Dev
// builds also log the path and body of any failing Supabase request (see
// supabaseFetchDiagnostics.js).
const fetchForClient = createDiagnosticFetch(
  createNoStoreFetch(typeof window !== 'undefined' ? window.fetch.bind(window) : globalThis.fetch),
  { enabled: Boolean(import.meta.env.DEV) },
);

export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  ...(fetchForClient ? { global: { fetch: fetchForClient } } : {}),
});
